import { jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright (c) Selfcity, Inc.
 * All rights reserved.
 */
import * as React from "react";
import { Tag } from "antd";
/**
 * InboxTasksFilterTag.
 */
function InboxTasksFilterTag({ id, title, reachedDueDateTasks = 0, tasksTotalNumber = 0, checked = false, onTagToggle, }) {
    return (_jsxs(Tag.CheckableTag, { checked: checked, className: tasksTotalNumber === 0 ? "task-tag__disabled" : "task-tag", onChange: (checked) => onTagToggle(id, checked), children: [title, reachedDueDateTasks > 0 ? (_jsxs(_Fragment, { children: [_jsxs("span", { className: "fc-sc-red", children: ["\u00A0", reachedDueDateTasks] }), "/"] })) : (_jsx(_Fragment, { children: "\u00A0" })), tasksTotalNumber] }, title));
}
export default React.memo(InboxTasksFilterTag);
